export default __webpack_public_path__ + "f3b6864.png";